import React, { useCallback } from 'react';
import { useRouter } from 'expo-router';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { LoadingPlaceholder, theme, useResponsive } from '@sg/garnish';

import { useTelemetry } from '@order/Telemetry';

import { SavedPaymentMethod } from '../SavedPaymentMethod';

export const AdditionalPaymentMethods = () => {
  const router = useRouter();

  const hasEnrolledToFlex = false; // to be replaced by graphql query.
  const isLoadingAccounts = false; // to be replaced by graphql query

  const { track } = useTelemetry();
  const { match } = useResponsive();

  const { formatMessage } = useIntl();
  const unlinkedMessage = match([
    messages.flexUnlinkedXS,
    messages.flexUnlinkedXS,
    messages.flexUnlinkedLG,
  ]);

  const flexText = hasEnrolledToFlex
    ? formatMessage(messages.flexLinked)
    : formatMessage(unlinkedMessage, { br: renderBreak });

  // ─── Callbacks ───────────────────────────────────────────────────────

  const handleLinkFlexAccount = useCallback(() => {
    if (hasEnrolledToFlex) return;

    track('payments.hsafsa.pressed');
    router.navigate('/hsa-fsa');
  }, [router, track]);

  if (isLoadingAccounts) {
    return <LoadingPlaceholder rows={3} rowHeight={32} palette="cream" />;
  }

  return (
    <View style={styles.container}>
      <SavedPaymentMethod
        icon="IconFlex"
        description={flexText}
        a11yLabel={formatMessage(messages.flexAccessibilityLabel)}
        isSuccess={hasEnrolledToFlex}
        onPress={handleLinkFlexAccount}
      />
    </View>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  flexAccessibilityLabel: {
    defaultMessage: 'Link your Flex account',
    description: 'Additional Payment Methods | Flex Accessibility Label',
  },
  flexUnlinkedXS: {
    defaultMessage: 'Link your Flex account - <br></br>pay using your HSA / FSA',
    description: 'Additional Payment Methods | Flex Unlinked',
  },
  flexUnlinkedLG: {
    defaultMessage: 'Link your Flex account - pay using your HSA / FSA',
    description: 'Additional Payment Methods | Flex Unlinked',
  },
  flexLinked: {
    defaultMessage: 'Flex account has been linked',
    description: 'Additional Payment Methods | Flex Linked',
  },
});

function renderBreak() {
  return '\n';
}

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: theme.spacing['6'],
    backgroundColor: theme.colors.OPACITY.WHITE.DARKEST,
    borderRadius: theme.radius.large,
    borderColor: theme.colors.GRAY,
    borderWidth: 1,
  },
});
